import { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router";
import { GlobalContext } from "../../../context/Context";
import Style from "./style.module.css";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronRight, ChevronsRight } from "lucide-react";

const AsideBar = () => {
  const location = useLocation();
  let { state } = useContext(GlobalContext);
  const [one] = useState(1);
  let dashboardRole = state?.user?.dashboardRole === "single";
  // const leftVideoRef = useRef(null);
  // const [leftLoaded, setLeftLoaded] = useState(false);
  // const [allReady, setAllReady] = useState(false);
  // useEffect(() => {
  //   if (leftLoaded) {
  //     setAllReady(true);
  //   }
  // }, [leftLoaded]);

  // useEffect(() => {
  //   if (allReady) {
  //     const left = leftVideoRef.current;

  //     const playVideos = async () => {
  //       try {
  //         await left?.play();
  //       } catch (err) {
  //         console.warn("Autoplay blocked, waiting for user interaction", err);

  //         // fallback: wait for user click to start
  //         const handleUserInteraction = async () => {
  //           await left?.play();
  //           window.removeEventListener("click", handleUserInteraction);
  //         };
  //         window.addEventListener("click", handleUserInteraction);
  //       }
  //     };

  //     playVideos();
  //   }
  // }, [allReady]);

  console.log("Location", location);

  const navItems = [
    {
      title: "Home",
      url: dashboardRole ? "#" : "/dashboard/overview",
      isActive: location.pathname.split("/")[one] === "dashboard",
      icon: `${state.basePath}/dashboard/aside/png/home.png`,
      iconHover: `${state.basePath}/dashboard/aside/png/home-hover.png`,
      subMenu: true,
      subMenuList: [{ title: "Dashboard", url: "/dashboard/overview" }],
    },
    {
      title: "Leads",
      url: dashboardRole ? "#" : `/leads/my-leads/dashboard`,
      isActive: location.pathname.split("/")[one] === "leads",
      icon: `${state.basePath}/dashboard/aside/png/leads.png`,
      iconHover: `${state.basePath}/dashboard/aside/png/leads-hover.png`,
      subMenu: true,
      subMenuList: [
        { title: "My Leads", url: "/leads/my-leads/dashboard" },
        { title: "My Team", url: "/leads/team/dashboard" },
        { title: "Organization", url: "/leads/organization/dashboard" },
      ],
    },
    {
      title: "Accounts",
      url: dashboardRole ? "#" : `/accounts/account/dashboard`,
      isActive: location.pathname.split("/")[one] === "accounts",
      icon: `${state.basePath}/dashboard/aside/png/accounts.png`,
      iconHover: `${state.basePath}/dashboard/aside/png/accounts-hover.png`,
      subMenu: true,
      subMenuList: [
        { title: "Accounts", url: "/accounts/account/dashboard" },
        { title: "My Team", url: "/accounts/team/overview" },
        { title: "Organization", url: "/accounts/organization/overview" },
      ],
    },
    {
      title: "Deals",
      url: dashboardRole ? "#" : `/deals/deal/dashboard`,
      isActive: location.pathname.split("/")[one] === "deals",
      icon: `${state.basePath}/dashboard/aside/png/deals.png`,
      iconHover: `${state.basePath}/dashboard/aside/png/deals-hover.png`,
      subMenu: true,
      subMenuList: [
        { title: "Deals", url: "/deals/deal/dashboard" },
        { title: "My Team", url: "/deals/team/dashboard" },
        { title: "Organization", url: "/deals/organization/dashboard" },
      ],
    },
    // {
    //   title: "Logs",
    //   url: dashboardRole ? "#" : `/logs/log`,
    //   isActive: location.pathname.split("/")[one] === "logs",
    //   icon: `${state.basePath}/dashboard/aside/png/activity.png`,
    //   iconHover: `${state.basePath}/dashboard/aside/png/activity-hover.png`,
    //   subMenu: true,
    //   subMenuList: [{ title: "Activity", url: "/logs/log" }],
    // },
    ,
    {
      title: "Activites",
      url: dashboardRole ? "#" : `/activites/activity/overview`,
      isActive: location.pathname.split("/")[one] === "activites",
      icon: `${state.basePath}/dashboard/aside/png/followup.png`,
      iconHover: `${state.basePath}/dashboard/aside/png/followup-hover.png`,
      subMenu: true,
      subMenuList: [
        { title: "Follow ups", url: "/activites/activity/overview" },
        { title: "My Team", url: "/activites/team/overview" },
        { title: "Organization", url: "/activites/organization/overview" },
      ],
    },
    {
      title: "Projects",
      url: dashboardRole ? "#" : `/projects/my-projects/dashboard`,
      isActive: location.pathname.split("/")[one] === "projects",
      icon: `${state.basePath}/dashboard/aside/png/projects.png`,
      iconHover: `${state.basePath}/dashboard/aside/png/projects-hover.png`,
      subMenu: true,
      subMenuList: [
        { title: "Projects", url: "/projects/my-projects/dashboard" },
        { title: "My Team", url: "/projects/team-projects/dashboard" },
        { title: "Organization", url: "/projects/organization-projects/dashboard" },
      ],
    },
    {
      title: "Sales",
      url: dashboardRole ? "#" : `/sales/sale/overview`,
      isActive: location.pathname.split("/")[one] === "sales",
      icon: `${state.basePath}/dashboard/aside/png/followup.png`,
      iconHover: `${state.basePath}/dashboard/aside/png/followup-hover.png`,
      subMenu: true,
      subMenuList: [
        { title: "Sales", url: "/sales/sale/overview" },
        { title: "My Team", url: "/sales/team/overview" },
        { title: "Organization", url: "/sales/organization/overview" },
      ],
    },
  ].filter(Boolean);

  const [expend, setExpend] = useState(false);
  const [activeNav, setActiveNav] = useState([]);

  const expendFind = (idx) => {
    if (expend) {
      setActiveNav((prev, i) =>
        prev?.includes(idx) ? prev?.filter((v) => v !== idx) : [...prev, idx],
      );
    }
    //  // }
  };

  const [showSubMenu, setShowSubMenu] = useState(false);

  useEffect(() => {
    let timer;

    if (!expend) {
      timer = setTimeout(() => {
        setShowSubMenu(true);
      }, 200);
    } else {
      setShowSubMenu(false);
    }

    return () => clearTimeout(timer);
  }, [expend]);

  console.log("location?.pathname?.split('')", location?.pathname?.split("/"));

  return (
    <motion.aside
      className={expend ? `${Style.isExpend} isExpend` : ""}
      animate={{ width: expend ? 187 : 78 }}
      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className={`${Style.aside_top}`}>
        <div className="px-[10px] w-full h-fit flex-shrink-0 overflow-hidden">
          <div className={`${Style.aside_userProfle}`}>
            <div className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="31"
                height="37"
                viewBox="0 0 31 37"
                fill="none"
              >
                <path
                  d="M20.0989 5.95C22.5725 5.95011 24.595 7.91437 24.595 10.7225C24.5949 12.2558 23.8384 13.8443 22.7952 14.7117L22.4436 15.0037L22.8782 15.1424C25.3911 15.9447 26.8242 17.7399 27.6331 19.5955C28.4441 21.4563 28.6204 23.3634 28.6204 24.3377C28.6204 25.4617 28.6084 26.3894 27.6282 27.0896C27.1218 27.4513 26.3399 27.7643 25.1252 27.9852C23.9122 28.2057 22.2836 28.3318 20.0989 28.3318C17.914 28.3318 16.2856 28.2057 15.0725 27.9852C13.8579 27.7643 13.076 27.4513 12.5696 27.0896C11.5893 26.3894 11.5774 25.4617 11.5774 24.3377C11.5774 23.3575 11.7375 21.39 12.5325 19.4705C13.3256 17.5555 14.741 15.7071 17.2463 14.9061L17.6809 14.7674L17.3303 14.4754C16.2839 13.6054 15.6019 12.2518 15.6018 10.7225C15.6018 8.07542 17.6305 5.95 20.0989 5.95Z"
                  fill="url(#paint0_linear_7997_3451)"
                  stroke="white"
                  stroke-width="0.5"
                />
                <g filter="url(#filter0_d_7997_3451)">
                  <path
                    d="M15.3271 14.904C16.4301 13.9871 17.218 12.3269 17.218 10.7223C17.218 7.78394 15.0908 5.7 12.4712 5.7C9.85166 5.7 7.7245 7.95066 7.7245 10.7223C7.7245 12.3269 8.44012 13.7509 9.54309 14.6679C4.34992 16.3281 3.69995 22.3367 3.69995 24.3373C3.69995 26.5602 3.69995 28.5816 12.4712 28.5816C21.2425 28.5816 21.2425 26.5602 21.2425 24.3373C21.2425 22.3437 20.5269 16.5642 15.3271 14.904Z"
                    fill="url(#paint1_linear_7997_3451)"
                  />
                  <path
                    d="M12.4714 5.95C14.9451 5.95011 16.9675 7.91437 16.9675 10.7225C16.9675 12.2558 16.2109 13.8443 15.1677 14.7117L14.8162 15.0037L15.2507 15.1424C17.7637 15.9447 19.1968 17.7399 20.0056 19.5955C20.8167 21.4563 20.9929 23.3634 20.9929 24.3377C20.9929 25.4617 20.981 26.3894 20.0007 27.0896C19.4944 27.4513 18.7125 27.7643 17.4978 27.9852C16.2847 28.2057 14.6562 28.3318 12.4714 28.3318C10.2866 28.3318 8.65817 28.2057 7.44507 27.9852C6.23042 27.7643 5.44854 27.4513 4.94214 27.0896C3.96189 26.3894 3.94995 25.4617 3.94995 24.3377C3.94995 23.3575 4.11005 21.39 4.90503 19.4705C5.69816 17.5555 7.11354 15.7071 9.6189 14.9061L10.0535 14.7674L9.70288 14.4754C8.65649 13.6054 7.97442 12.2518 7.97437 10.7225C7.97437 8.07542 10.003 5.95 12.4714 5.95Z"
                    stroke="url(#paint2_linear_7997_3451)"
                    stroke-width="0.5"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_7997_3451"
                    x="-4.86374e-05"
                    y="9.53674e-07"
                    width="30.9425"
                    height="36.2816"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="3" dy="1" />
                    <feGaussianBlur stdDeviation="3.35" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.145098 0 0 0 0 0.388235 0 0 0 0 0.921569 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_7997_3451"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_7997_3451"
                      result="shape"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_7997_3451"
                    x1="17.3765"
                    y1="4.13989"
                    x2="31.5838"
                    y2="18.4441"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" />
                    <stop offset="1" stop-color="#0B54FF" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_7997_3451"
                    x1="20.8235"
                    y1="17.1408"
                    x2="3.8429"
                    y2="17.1408"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#BCBCBC" />
                    <stop offset="1" stop-color="white" />
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_7997_3451"
                    x1="3.90879"
                    y1="26.8867"
                    x2="17.7797"
                    y2="16.231"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#335CFF" />
                    <stop offset="1" stop-color="white" />
                  </linearGradient>
                </defs>
              </svg>
            </div>

            <div className="text-white text-[11px] font-semibold leading-[1]">
              CRM
            </div>
          </div>
        </div>

        <div
          className={`${Style?.aside_navBar} ${expend ? Style?.aside_navBar_expend : ""}`}
        >
          {navItems?.map((item, idx) => {
            return (
              <div key={`nav_row_${idx}`} className={`${Style?.nav_row}`}>
                <motion.div
                  onClick={() => {
                    if (item?.subMenu) {
                      expendFind(idx);
                    }
                  }}
                  className={`${Style?.nav_button}`}
                  animate={{
                    flexDirection: expend ? "row" : "column",
                    alignItems: expend ? "center" : "center",
                    gap: expend ? "10px" : "10px",
                  }}
                  transition={{ duration: 0.25, ease: "easeInOut" }}
                >
                  <Link
                    to={item?.url}
                    className={`${Style?.nav_link} ${activeNav?.includes(idx) && expend ? Style.active : null} ${item?.isActive ? Style.active : ""} `}
                  >
                    <div className={`${Style?.icon}`}>
                      <img
                        src={`${item?.icon}`}
                        width={46}
                        height={46}
                        alt={`normal_${idx}_${item?.title}`}
                      />
                    </div>
                    <div className={`${Style?.icon} ${Style?.iconHover}`}>
                      <img
                        src={item?.iconHover}
                        width={46}
                        height={46}
                        alt={`hover_${idx}_${item?.title}`}
                      />
                    </div>
                  </Link>

                  <AnimatePresence mode="wait">
                    <motion.span
                      key={expend ? "expanded" : "collapsed"}
                      className={`${Style.nav_lable} truncate ${activeNav?.includes(idx) && expend ? Style.active : null} ${item?.isActive ? Style.active : ""} `}
                      initial={{
                        opacity: 0,
                        x: expend ? -3 : 0,
                        y: expend ? 0 : 3,
                      }}
                      animate={{ opacity: 1, x: 0, y: 0 }}
                      exit={{
                        opacity: 0,
                        x: expend ? -3 : 0,
                        y: expend ? 0 : 3,
                      }}
                      transition={{ duration: 0.15, ease: "easeOut" }}
                    >
                      {item.title}
                    </motion.span>
                  </AnimatePresence>
                </motion.div>

                {expend ? (
                  // "expanded"
                  <div
                    className={`${Style.nav_subMenuWrapp2} ${activeNav?.includes(idx) ? Style?.isOpen : null}`}
                  >
                    <div className={`${Style?.nav_subMenuBody}`}>
                      {item?.subMenuList?.map((subItems, subIdx) => {
                        const isActive =
                          location?.pathname?.split("/").length > 3
                            ? `${location?.pathname?.split("/")[1]}-${location?.pathname?.split("/")[2]}` ==
                            `${subItems?.url?.split("/")[1]}-${subItems?.url?.split("/")[2]}`
                            : `${location?.pathname?.split("/")[1]}` ==
                            `${subItems?.url?.split("/")[1]}`;
                        return (
                          <Link
                            to={subItems?.url || "#"}
                            className={`${Style?.nav_subMenuItems} ${isActive ? Style?.isActive : null}`}
                            key={`subMenu_${idx}_${subIdx}`}
                          >
                            {subItems?.title}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  showSubMenu && (
                    <div className={`${Style.nav_subMenuWrapp}`}>
                      <div className={`${Style?.nav_subMenuHead}`}>
                        <img
                          className={`${Style?.nav_subMenuIcon}`}
                          src={`${item?.icon}`}
                          width={26}
                          height={26}
                          alt={item?.title}
                        />
                        <span className={`${Style?.nav_subMenuLable}`}>
                          {item?.title}
                        </span>
                      </div>

                      <div className={`${Style?.nav_subMenuBody}`}>
                        {item?.subMenuList?.map((subItems, subIdx) => {
                          const isActive =
                            location?.pathname?.split("/").length > 3
                              ? `${location?.pathname?.split("/")[1]}-${location?.pathname?.split("/")[2]}` ==
                              `${subItems?.url?.split("/")[1]}-${subItems?.url?.split("/")[2]}`
                              : `${location?.pathname?.split("/")[1]}` ==
                              `${subItems?.url?.split("/")[1]}`;
                          return (
                            <Link
                              to={subItems?.url || "#"}
                              className={`${Style?.nav_subMenuItems} ${isActive ? Style?.isActive : null}`}
                              key={`subMenu_${idx}_${subIdx}`}
                            >
                              {subItems?.title}
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  )
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className={Style.aside_bottom}>
        <motion.button
          type="button"
          className={Style.collapseBtn}
          onClick={() => {
            setTimeout(() => {
              setExpend((prev) => !prev);
            }, 5);
          }}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.92 }}
          aria-label={expend ? "Collapse sidebar" : "Expand sidebar"}
          title={expend ? "Collapse sidebar" : "Expand sidebar"}
        >
          <motion.span
            animate={{ rotate: expend ? 180 : 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
          >
            <ChevronsRight size={18} strokeWidth={2.2} />
          </motion.span>
        </motion.button>
      </div>
    </motion.aside>
  );
};

export default AsideBar;
